/* eslint-disable @intercom/intercom/no-bare-strings */

import { camelize } from '@ember/string';
export const UPLOAD_RETRY_CLASS = 'embercom-prosemirror-retry-upload';
export const UPLOAD_FILE_GUID = 'file-guid';

// This function decorates the passed in node spec to make it work as an uploadable object.
// This involves adding attrs to store upload state on the node and wrapping the toDom method
// so that an upload failure overlay is shown if the upload fails.

// This module also exposes two helpers, one to be used to detect clicks on the retry link
// and attempt a retry, and another to take an UploadResult and map it to the upload attrs
// added by the decorator
export function uploadable(spec) {
  spec.attrs = Object.assign({}, spec.attrs, {
    fileGUID: {
      default: ''
    },
    uploadFailed: {
      default: false
    },
    failureReason: {
      default: ''
    },
    retryable: {
      default: true
    }
  });
  let wrappedToDOM = spec.toDOM;
  spec.toDOM = node => {
    let output = wrappedToDOM(node);
    output[1][UPLOAD_FILE_GUID] = node.attrs?.fileGUID;
    if (node.attrs?.uploadFailed === true) {
      let retry = [];
      if (node.attrs.retryable) {
        let outputAttrs = {
          class: UPLOAD_RETRY_CLASS
        };
        outputAttrs[`data-${UPLOAD_FILE_GUID}`] = node.attrs?.fileGUID;
        retry = ['a', outputAttrs, 'try again'];
      }
      return ['div', {
        class: 'embercom-prosemirror-upload-failed'
      }, ['div', {
        class: 'embercom-prosemirror-upload-failed-inner'
      }, ['div', {
        class: 'embercom-prosemirror-upload-info'
      }, createWarningSVG(), node.attrs.failureReason], retry], output];
    }
    return output;
  };
  return spec;
}
export function handleUploadRetry(composer, e) {
  if (e.target?.classList.contains(UPLOAD_RETRY_CLASS)) {
    composer?.commands.retryUpload(e.target?.dataset[camelize(UPLOAD_FILE_GUID)]);
  }
}
export function uploadResultToNodeAttrs(uploadResult) {
  if (uploadResult.type === 'success') {
    return {
      fileGUID: '',
      uploadFailed: false,
      failureReason: ''
    };
  } else {
    return {
      uploadFailed: true,
      failureReason: uploadResult.reason,
      retryable: uploadResult.retryable
    };
  }
}
function createWarningSVG() {
  let icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  icon.setAttributeNS(null, 'fill', 'red');
  icon.setAttribute('class', 'interface-icon o__standard o__by-text');
  icon.setAttributeNS(null, 'viewBox', '0 0 16 16');
  let path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  path.setAttributeNS(null, 'fill-rule', 'oddeven');
  path.setAttributeNS(null, 'd', 'M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0-6.083a.701.701 0 0 1-.697-.621L6.88 4.615A1 1 0 0 1 7.872 3.5h.256a1 1 0 0 1 .993 1.115l-.424 3.68A.701.701 0 0 1 8 8.918zM8 12.5c-.714 0-1.25-.536-1.25-1.25S7.286 10 8 10s1.25.536 1.25 1.25S8.714 12.5 8 12.5z');
  icon.appendChild(path);
  return icon;
}